<template>
    <span v-if="resourcesCount>0 || staffVehicules.length>0"
        :data-component-name="$options.name"
    >
        <!-- {{ attributes }} -->
        <q-btn v-bind="$attrs" :round="round">
            <q-menu>
                <q-list dense style="min-width: 100px">
                    <div
                    :key="index"
                    v-for="(resourceType, index) in attributes"
                    >
                        <q-item clickable v-if="resourceType.resources.length>0">
                            <q-item-section>{{ resourceType.name }}</q-item-section>
                            <q-item-section side>
                                <q-icon name="keyboard_arrow_right" />
                            </q-item-section>

                            <q-menu dense auto-close anchor="top right" self="top left">
                                <q-list>
                                    <div>
                                        <q-item
                                            v-for="(resource, n) in resourceType.resources"
                                            :key="n"
                                            clickable
                                            @click="$emit('add-resource', resource)"
                                        >
                                            <q-item-section>
                                                {{ resource.name }}
                                                <div class="o-resource-description" v-if="resource.description && resource.description.trim()!=''">
                                                    <small>{{ resource.description }}</small>
                                                </div>
                                            </q-item-section>
                                        </q-item>
                                    </div>
                                </q-list>
                            </q-menu>
                        </q-item>
                    </div>

                    <div>
                        <q-item clickable v-if="staffVehicules && staffVehicules.length>0">
                            <q-item-section>Véhicules d'employé</q-item-section>
                            <q-item-section side>
                                <q-icon name="keyboard_arrow_right" />
                            </q-item-section>

                            <q-menu dense auto-close anchor="top right" self="top left">
                                <q-list>
                                    <div>
                                        <q-item
                                            v-for="(resource, n) in staffVehicules"
                                            :key="n"
                                            clickable
                                            @click="$emit('add-resource', resource)"
                                        >
                                            <q-item-section>
                                                {{ resource.userProfile.name + ' : ' + resource.name }}
                                                <div class="o-resource-description" v-if="resource.description && resource.description.trim()!=''">
                                                    <small>{{ resource.description }}</small>
                                                </div>
                                            </q-item-section>
                                        </q-item>
                                    </div>
                                </q-list>
                            </q-menu>
                        </q-item>
                    </div>
                </q-list>
            </q-menu>
        </q-btn>
    </span>
</template>

<script>
    import { RESOURCETYPESRESOURCES } from '@/graphql/resource/queries'
    import orderBy from "lodash/orderBy";

    export default {
        name: "AddResourcesMenu",
        props: {
            resourcesModel: {
                type: String,
                default: "PROJECTS"
            },
            round: {
                type: Boolean,
                default: false
            },
            staffVehicules: {
                type: Array,
                default: null
            }
        },
        data(){
            return {
                // attributes: []
            }
        },
        methods: {

        },
        mounted() {
        },
        computed: {
            attributes(){
                if(!this.resourceTypes) return [];
                return orderBy(this.resourceTypes, [item => item.name.toLowerCase()]);
            },
            resourcesCount(){
                if(!this.attributes) return 0;
                let resourcesCount=0;
                this.attributes.forEach(function(item){
                    resourcesCount=resourcesCount+item.resources.length
                })
                return resourcesCount;
            }
        },
        apollo: {
            resourceTypes: {
                query: RESOURCETYPESRESOURCES,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables() {
                    return {
                        model: this.resourcesModel
                    }
                },
                update(data) {
                    // this.attributes=data.resourceTypes;
                    return data.resourceTypes;
                }
            },
        }
    }
</script>

<style lang="scss">
    .o-resource-description {
        line-height: 0.7rem;
        font-weight: normal;
    }
</style>